import React from 'react'
import PropTypes from 'prop-types'

import CtaButton from 'components/cta-button'

import box from './images/box-icon.png'
import styles from './styles.module.scss'

const EmptyList = ({ resetFilters }) => (
  <div className="align-center">
    <img src={box} alt="no lenders found" className={`${styles.box} mb-24 mt-48`} />
    <p type="bodyLarge" weight="bold" color="neutral" className="mb-24 bodyLarge bold">
      Oh no! We couldn’t find you any results
    </p>
    <CtaButton size="small" className="mb-48" onClick={resetFilters}>
      Reset Filter
    </CtaButton>
  </div>
)

EmptyList.propTypes = {
  resetFilters: PropTypes.func,
}

export { EmptyList }

export default EmptyList
